module.exports = __webpack_public_path__ + "img/category-fishing-game.37e07713.png";